<template>
  <div class="footer">
    <v-footer color="transparent" class="py-2 body-2" inset app absolute>
      <div class="grey--text">
        <div class="mr-10">
          Version {{ appVersion }} (Beta)
          <span v-if="isSupport"> ({{ environment }})</span>
        </div>
        <div>
          <a
            href="https://docs.mira-one.com/impressum"
            class="grey--text text-decoration-none"
            target="_blank"
            rel="noopener noreferrer"
            >Impressum</a
          >
          <span> – </span>
          <a
            href="https://docs.mira-one.com/datenschutz"
            class="grey--text text-decoration-none"
            target="_blank"
            rel="noopener noreferrer"
            >Datenschutzerklärung</a
          >
          <span> – </span>
          <!-- <a
            href="https://docs.mira-one.com/cookies"
            class="grey--text text-decoration-none"
            target="_blank"
            rel="noopener noreferrer"
            >Verwendung von Cookies</a
          >
          <span> – </span> -->
          <a
            href="https://docs.mira-one.com/agb"
            class="grey--text text-decoration-none"
            target="_blank"
            rel="noopener noreferrer"
            >AGB</a
          >
        </div>
        <v-spacer></v-spacer>
        <div>
          &copy; {{ new Date().getFullYear() }} Alle Rechte vorbehalten.
          Mira&nbsp;Digital&nbsp;Solutions&nbsp;UG&nbsp;(haftungsbeschränkt)
        </div>
      </div>
    </v-footer>
  </div>
</template>

<style></style>

<script>
import { VERSION_CONFIG } from "@/config/version";

export default {
  computed: {
    appVersion() {
      return VERSION_CONFIG.CURRENT_VERSION;
    },
    environment() {
      return process.env.NODE_ENV || "Unknown";
    },
    isSupport() {
      // Check for support user at both organization and global level
      try {
        const orgSupport =
          this.$store.getters["organization/checkIfSupport"] || false;
        const userSupport = this.$store.getters["user/checkIfSupport"] || false;
        return orgSupport || userSupport;
      } catch (error) {
        // If store isn't available or there's an error, default to false
        return false;
      }
    },
  },
};
</script>
